import { useRef } from "react";

export function usePromise<T>() {
  const ref = useRef<{
    promise: Promise<T>;
    resolve: (value: T) => void;
  } | null>(null);

  if (!ref.current) {
    let resolve: (value: T) => void;

    const promise = new Promise<T>((res) => {
      resolve = res;
    });

    ref.current = { promise, resolve: resolve! };
  }

  return ref.current;
}
